import React, { ReactElement } from 'react';
import { SxStyle } from '../../types';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';

const styles: SxStyle = {
  mobile: (theme) => ({
    height: '100%',
    width: '300px',
    [theme.breakpoints.up('md')]: {
      width: 340,
    },
    border: '2px solid #ccc',
    borderRadius: '30px',
    position: 'relative',
    background: '#fff',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  }),
  tablet: {
    height: '100%',
    minWidth: 510,
    flexBasis: '510px',
    flexShrink: 0,
    flexGrow: 0,
    borderTop: '1px solid #ccc',
    borderBottom: '1px solid #ccc',
    borderRadius: '30px',
    position: 'relative',
    background: '#fff',
    overflow: 'hidden',
    marginTop: '12px',
    display: 'flex',
    flexDirection: 'column',
  },
  mobileScreen: {
    flex: '1 1 auto',
    borderTop: '1px solid #ccc',
    borderBottom: '1px solid #ccc',
    boxSizing: 'border-box',
    overflowY: 'auto',
    overflowX: 'hidden',

    overflowScrolling: 'touch',
    background: `
            /* Shadow Cover TOP */
            linear-gradient(
              white 30%,
              rgba(255, 255, 255, 0)
            ) center top,

            /* Shadow Cover BOTTOM */
            linear-gradient(
              rgba(255, 255, 255, 0),
              white 70%
            ) center bottom,

            /* Shadow TOP */
            radial-gradient(
              farthest-side at 50% 0,
              rgba(0, 0, 0, 0.2),
              rgba(0, 0, 0, 0)
            ) center top,

            /* Shadow BOTTOM */
            radial-gradient(
              farthest-side at 50% 100%,
              rgba(0, 0, 0, 0.2),
              rgba(0, 0, 0, 0)
            ) center bottom
        `,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 40px, 100% 40px, 100% 14px, 100% 14px',
    backgroundAttachment: 'local, local, scroll, scroll',
  },
  tabletScreen: {
    width: '480px',
    flex: '1 1 auto',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
    overflowY: 'auto',
    overflowX: 'hidden',

    overflowScrolling: 'touch',
    background: `
            /* Shadow Cover TOP */
            linear-gradient(
              white 30%,
              rgba(255, 255, 255, 0)
            ) center top,

            /* Shadow Cover BOTTOM */
            linear-gradient(
              rgba(255, 255, 255, 0),
              white 70%
            ) center bottom,

            /* Shadow TOP */
            radial-gradient(
              farthest-side at 50% 0,
              rgba(0, 0, 0, 0.2),
              rgba(0, 0, 0, 0)
            ) center top,

            /* Shadow BOTTOM */
            radial-gradient(
              farthest-side at 50% 100%,
              rgba(0, 0, 0, 0.2),
              rgba(0, 0, 0, 0)
            ) center bottom
        `,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 40px, 100% 40px, 100% 14px, 100% 14px',
    backgroundAttachment: 'local, local, scroll, scroll',
  },
  home: {
    width: '36px',
    height: '36px',
    border: '1px solid #ccc',
    borderRadius: '50%',
  },
  speaker: {
    width: '50px',
    height: '6px',
    border: '1px solid #ccc',
    borderRadius: '6px',
  },
  camera: {
    width: '8px',
    height: '8px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    transform: 'translateX(-50%)',
  },
  header: {
    position: 'relative',
    py: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  bottom: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    py: '10px',
  },
};

type MobileDeviceProps = {
  device: string;
  displayDevice: boolean;
  showPreview?: boolean;
  header?: ReactElement | null;
  children: React.ReactNode;
  height?: string;
};

function MobileDevice({ device, displayDevice, header, height, children }: MobileDeviceProps) {
  const currentDevice = device?.toLowerCase();

  if (!displayDevice) {
    return null;
  }

  const deviceStyle = {
    ...(currentDevice === 'mobile' ? styles.mobileScreen : styles.tabletScreen),
    ...(height
      ? {
          height,
        }
      : {}),
  };

  return (
    <Box
      sx={(theme) => ({
        pt: '10px',
        // [theme.breakpoints.up('sm')]: {
        //   height: 'calc(100% - 20px)',
        // },
      })}
    >
      <Paper sx={currentDevice === 'mobile' ? styles.mobile : styles.tablet} elevation={2}>
        <Box sx={styles.header}>
          {!header ? (
            <Box sx={currentDevice === 'mobile' ? styles.speaker : styles.camera} />
          ) : (
            <Box>{header}</Box>
          )}
        </Box>
        <Box sx={deviceStyle}>{children}</Box>
        <Box sx={styles.bottom}>
          <Box sx={styles.home} />
        </Box>
      </Paper>
    </Box>
  );
}

export default MobileDevice;
